/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Output_DescInputs */

const es_prompt_tips_output_desc = /** @type {(inputs: Prompt_Tips_Output_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lugar de "armá un reporte", especificá qué datos, valores y formato esperás ver. Cuanto más específico seas, mejor será el output.`)
};

const en_prompt_tips_output_desc = /** @type {(inputs: Prompt_Tips_Output_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instead of "create a report", specify what data, values, and format you expect to see. The more specific you are, the better the output.`)
};

/**
* | output |
* | --- |
* | "Instead of \"create a report\", specify what data, values, and format you expect to see. The more specific you are, the better the output." |
*
* @param {Prompt_Tips_Output_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_output_desc = /** @type {((inputs?: Prompt_Tips_Output_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Output_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_output_desc(inputs)
	return en_prompt_tips_output_desc(inputs)
});
export { prompt_tips_output_desc as "prompt_tips.output_desc" }